import React from "react";
import "./Setiting.css";
import { Link, useLocation } from "react-router-dom";
import HeaderNavigation from "../Common/header Navigation/HeaderNavigation";
import { useAuth } from "../../context/AuthContext";

const Setting = () => {
  const { modules } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();

  // Find the Setting module itself
  const settingModule = modules.find(m => m.moduleUrl?.toLowerCase() === currentPath);
  
  // Find all children of Setting
  const settingChildren = modules
    .filter(m => m.parentModuleId === settingModule?._id && m.status)
    .sort((a, b) => (Number(a.displayOrder) || 0) - (Number(b.displayOrder) || 0));

  // Group modules by cardTitle
  const groupedModules = settingChildren.reduce((acc, module) => {
    const title = (module.cardTitle || "GENERAL").toUpperCase();
    if (!acc[title]) {
      acc[title] = [];
    }
    acc[title].push(module);
    return acc;
  }, {});

  // Get titles in an order that respects the first appearance of displayOrder
  const orderedTitles = Object.keys(groupedModules).sort((a, b) => {
    const minOrderA = Math.min(...groupedModules[a].map(m => Number(m.displayOrder) || 0));
    const minOrderB = Math.min(...groupedModules[b].map(m => Number(m.displayOrder) || 0));
    return minOrderA - minOrderB;
  });

  return (
    <div className="setting-containermain">
      <header className="container-setting"></header>
      <HeaderNavigation value={"Master / Setting"} />

      <div className="settingpage-setting">
        {orderedTitles.length > 0 ? (
          orderedTitles.map((title) => (
            <div key={title}>
              <p className="MASTERS">{title}</p>
              {groupedModules[title]
                .sort((a, b) => (Number(a.displayOrder) || 0) - (Number(b.displayOrder) || 0))
                .map((subModule) => (
                  <Link key={subModule._id} to={subModule.moduleUrl || "#"}>
                    <button className="Positions" type="button" style={{ cursor: "pointer" }}>
                      {subModule.moduleName}
                    </button>
                  </Link>
                ))}
            </div>
          ))
        ) : (
          <div style={{ padding: "20px", textAlign: "center", width: "100%" }}>
            <p>No setting modules found for your account.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Setting;
